module.exports = __webpack_public_path__ + "img/bg_01.b0c62ef6.png";